export const SET_RESULT = 'SET_RESULT'
export const CHANGE_LOADING = 'CHANGE_LOADING'
export const CHANGE_TABLE_LOADING = 'CHANGE_TABLE_LOADING'
export const SHOW_RESULTS = 'SHOW_RESULTS'
export const SHOW_SEARCH_ERROR = 'SHOW_SEARCH_ERROR'
export const PARSE_DATA = 'PARSE_DATA'
export const CREATE_OBJECT_OF_ID = 'CREATE_OBJECT_OF_ID'
export const SELECT_ROW = 'SELECT_ROW'
export const SET_SORTING_BY = 'SET_SORTING_BY'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_HEIGHT_OF_TBODY = 'SET_HEIGHT_OF_TBODY'
export const APPLY_FILTER = 'APPLY_FILTER'
export const REMOVE_FILTER = 'REMOVE_FILTER'
export const SET_HISTORICAL_DATE = 'SET_HISTORICAL_DATE'
export const REMOVE_HISTORICAL_DATE = 'REMOVE_HISTORICAL_DATE'
export const REMOVE_CRITERIA = 'REMOVE_CRITERIA'
export const SET_CRITERIA = 'SET_CRITERIA'
export const RESET_CRITERIA = 'RESET_CRITERIA'
export const RESET_SIMPLE_FILTERS = 'RESET_SIMPLE_FILTERS'
export const ADD_CRITERIA = 'ADD_CRITERIA'
export const CLEAR_PARAMS = 'CLEAR_PARAMS'
export const SET_PER_PAGE = 'SET_PER_PAGE'
export const SET_ALL = 'SET_ALL'
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER'
export const CHANGE_SIMPLE_SEARCH = 'CHANGE_SIMPLE_SEARCH'
export const SET_FULLTEXT_FILTER = 'SET_FULLTEXT_FILTER'
export const CHANGE_MODE = 'CHANGE_MODE'
export const TOGGLE_EXPORT_MODAL = 'TOGGLE_EXPORT_MODAL'
export const SET_EXPORT_FORMAT = 'SET_EXPORT_FORMAT'
export const GOLDEN_COPY_PUBLISH_DATE = 'GOLDEN_COPY_PUBLISH_DATE'


// WEBPACK FOOTER //
// ./src/store/modules/search/mutations-types.js